import React from 'react';
import simericsLogo from '../assets/simerics-ai.png';

interface HeaderProps {
  onResetWizard?: () => void;
  saiFileName?: string | null;
}

export const Header: React.FC<HeaderProps> = ({ onResetWizard, saiFileName }) => {
  return (
    <div className="ai-wizard-header">
      <div
        className="ai-wizard-branding"
        onClick={onResetWizard}
        style={{ cursor: onResetWizard ? 'pointer' : 'default' }}
      >
        <div className="simerics-logo">
          <img src={simericsLogo} alt="Simerics AI" width="32" height="32" />
        </div>
        <span className="ai-wizard-title">Simerics AI</span>
      </div>
      {saiFileName && (
        <div className="ai-wizard-project">
          <span className="project-label">Current Project:</span>
          <span className="project-name">{saiFileName}</span>
          <button className="close-button" onClick={onResetWizard}>✕</button>
        </div>
      )}
    </div>
  );
};

